import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor, FiSmartphone, FiCamera, FiEdit, FiPercent, FiStar, FiPenTool, FiCloudLightning } from "react-icons/fi";

const InterestList = [
    {
        icon: <FiCloudLightning />,
        title: 'Site Reliability Engineering',
        description: `Designing resilient, observable, and scalable infrastructure by eliminating toil and keeps services running reliably at scale`
    },
    {
        icon: <FiMonitor />,
        title: 'Real-Time Systems',
        description: 'Exploring the synergy between hardware and high-speed software. Deeply interested in how low-latency architectures and IoT integrations can provide instantaneous insight and seamless control'
    },
    {
        icon: <FiPenTool />,
        title: 'AI & Machine Learning',
        description: "Dedicated to the evolution of intelligent systems. Exploring how automated workflows and predictive modeling can be woven into the fabric of modern business strategy"
    },
]


class InterestThree extends Component{
    render(){
        const {column } = this.props;
        const InterestContent = InterestList.slice(0 , this.props.item);
        
        return(
            <React.Fragment>
                <div className="row">
                    {InterestContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            <a>
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default InterestThree;
